import { get } from "lodash";

const getHistory = state => get(state, "debtor.history");

export default getHistory;
